import React from "react";

import { getApi } from '../../api/endpoints';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import ListingPageComponent from '../../components/ListingPageComponent';
import ComplaintCategoriesStats from '../../components/ComplaintCategoriesStats';
import UiAction from "../../components/UiAction.js";
import UI_ACTIONS from "../../data/UiActionConstants.js";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

const Index = () => {
  const navigate = useNavigate();
  const defaultHeaderConfig = { disableSort: true };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Complaint Category Name',
      attr: 'name',
    },
    {
      ...defaultHeaderConfig,
      label: 'Parent Category Name',
      value: (row) => {
        return <div className="d-block">
          {row.parent_category_name === null ? "-" : row.parent_category_name}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Description',
      value: (row) => {
        return <div className="d-block">
          {row.description === null ? "-" : row.description}
        </div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Last Updated At',
      attr: 'updated_at',
      disableSort: false
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_complaint_category.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onEditClick(row.id) }>
              <FontAwesomeIcon icon={faEdit}/>
            </div>
          </UiAction>
        </div>
      }
    },
  ]

  const onEditClick = (id) => {
    navigate(`/categories/${id}/edit`)
  }

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_complaint_category.name)}>
        <button className="s-btn me-2" onClick={onNewClick} style={{ width: "150px" }} >
          <span>Add New Category</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  const onNewClick = () => {
    navigate('/categories/new');
  }

  return <>
    <ListingPageComponent
      key={PAGES.ComplaintCategoriesListingPage.name}
      uiPage={uiManager.getUiPage(PAGES.ComplaintCategoriesListingPage.name)}
      breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Categories'}]}
      listingMutation={getApi('categories')}
      className="categories-listing-page"
      contentHeading="All Categories - Results"
      headers={headers}
      recordsKey="categories"
      contentTop={<ComplaintCategoriesStats />}
      tableHeaderActionsComponent={tableHeaderActionsComponent()}
      searchBy={['ID', 'Name']}
    />
  </>
};

export default Index;
